import type { CSSProperties } from 'react'

export type BillingCycle = 'monthly' | 'annual'

interface BillingToggleProps {
  cycle: BillingCycle
  onChange: (cycle: BillingCycle) => void
  hideAnnualBadge?: boolean
}

const PURPLE = '#7C3AED'
const GOLD = '#FBBF24'
const SURFACE = '#111118'
const BORDER = 'rgba(255,255,255,0.10)'

export default function BillingToggle({ cycle, onChange, hideAnnualBadge = false }: BillingToggleProps) {
  const tabStyle = (active: boolean): CSSProperties => ({
    padding: '10px 28px',
    border: '1px solid ' + BORDER,
    background: active ? PURPLE : SURFACE,
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 600,
    transition: 'background 0.15s',
  })
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <button
        type="button"
        onClick={() => onChange('monthly')}
        style={{ ...tabStyle(cycle === 'monthly'), borderRadius: '8px 0 0 8px' }}
      >
        Monthly
      </button>
      <button
        type="button"
        onClick={() => onChange('annual')}
        style={{ ...tabStyle(cycle === 'annual'), borderRadius: '0 8px 8px 0', borderLeft: 'none' }}
      >
        Annual
        {!hideAnnualBadge && (
          <span style={{ color: GOLD, fontSize: 12, marginLeft: 6 }}>Save 40%</span>
        )}
      </button>
    </div>
  )
}
